/**
 * Noop for default value
 */
// tslint:disable-next-line:no-empty
export const noop = () => {};

/**
 * Utility to compose the functions so you can call them together
 * @param fns functions that you want to call
 */
export const callAll = (...fns: any[]) => (...args: any[]) =>
  fns.forEach(fn => typeof fn === 'function' && fn(...args));



// WEBPACK FOOTER //
// ./src/util/fn-util.ts